import moment from 'moment-timezone';
export const freqTypes = {
  d: { freq: 'd', transId: 'detail_Daily', options: moment.weekdays() },
  w: { freq: 'w', transId: 'detail_Weekly', options: moment.weekdays() },
  m: { freq: 'm', transId: 'detail_Monthly', options: Array.from({ length: 31 }, (v, k) => k + 1) },
};

export const frequencies = Object.keys(freqTypes);
